<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect4"><span href="#/OEBPS/toc#sect4" title="Link target outside of Sample">Southern Johnny Cakes</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/10-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 4–6 | Prep Time: 5 minutes | Cook Time: 10–12 minutes</p>
<p class="extract_r">Johnny cakes are an American classic both in the Northeast and in the South. The addition of whole wheat flour helps add fiber, so if you want to indulge in a bit of maple syrup to top them off, go ahead!</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">½ cup whole wheat flour</p>
<p class="rec">1 cup self-rising cornmeal</p>
<p class="rec">1 teaspoon baking powder</p>
<p class="rec">1 tablespoon sugar</p>
<p class="rec">½ teaspoon kosher salt</p>
<p class="rec">2 large eggs, lightly beaten</p>
<p class="rec">1 cup buttermilk</p>
<p class="rec">1 tablespoon unsalted butter, melted</p>
<p class="rec">2 teaspoons vanilla extract</p>
<p class="rec">Greek yogurt and fresh berries for topping</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. In a large bowl, combine the flour, cornmeal, baking powder, sugar, and salt.</p>
<p class="recpr">2. Whisk in the eggs, buttermilk, butter, and vanilla.</p>
<p class="recpr">3. Coat a griddle or skillet with cooking spray and heat over medium-high heat.</p>
<p class="recpr">4. Drop about ¼ cup of the batter per cake onto the griddle and cook for 2 to 3 minutes per side until golden brown.</p>
<p class="recpr">5. Serve with Greek yogurt and fresh berries.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect4.vue?0808b3af